"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _immutable = require("immutable");

var I = _interopRequireWildcard(_immutable);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require("react-bootstrap");

require("./DropdownFilter.scss");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropdownFilter = (_temp2 = _class = function (_Component) {
  _inherits(DropdownFilter, _Component);

  function DropdownFilter() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DropdownFilter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DropdownFilter.__proto__ || Object.getPrototypeOf(DropdownFilter)).call.apply(_ref, [this].concat(args))), _this), _this.handleOptionSelect = function (query) {
      var pathname = _this.context.location.pathname;

      _this.props.onChange({
        pathname: _this.props.to || pathname,
        query: query
      });
    }, _this.renderOption = function (_ref2, idx) {
      var label = _ref2.label,
          value = _ref2.value;
      var query = _this.context.location.query;
      var _this$props = _this.props,
          multi = _this$props.multi,
          param = _this$props.param,
          queryToReset = _this$props.queryToReset;

      if (multi) {
        return _this.renderOptionForMulti({ label: label, value: value }, idx);
      }

      var newQuery = Object.assign({}, query, queryToReset, _defineProperty({}, param, value));

      return _react2.default.createElement(
        _reactBootstrap.MenuItem,
        {
          active: _this.currentValue.indexOf(value) >= 0,
          eventKey: idx,
          key: idx,
          onClick: _this.handleOptionSelect.bind(_this, newQuery) },
        label
      );
    }, _this.renderOptionForMulti = function (_ref3, idx) {
      var label = _ref3.label,
          value = _ref3.value;
      var query = _this.context.location.query;
      var _this$props2 = _this.props,
          param = _this$props2.param,
          queryToReset = _this$props2.queryToReset;


      var valueIdx = _this.currentValue.indexOf(value);
      var isValueSelected = valueIdx >= 0;

      var selectedItems = void 0;
      if (isValueSelected) {
        selectedItems = [].concat(_toConsumableArray(_this.currentValue));
        selectedItems.splice(valueIdx, 1);
      } else {
        selectedItems = [].concat(_toConsumableArray(_this.currentValue), [value]);
      }
      var newQuery = Object.assign({}, query, queryToReset, _defineProperty({}, param, selectedItems));

      return _react2.default.createElement(
        _reactBootstrap.MenuItem,
        {
          eventKey: idx,
          key: idx,
          onClick: _this.handleOptionSelect.bind(_this, newQuery) },
        _react2.default.createElement(
          _reactBootstrap.Checkbox,
          { checked: isValueSelected },
          label
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DropdownFilter, [{
    key: "getLabelByValues",
    value: function getLabelByValues() {
      var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var options = this.props.options;

      var valuesList = I.List(values);
      var selectedItems = options.filter(function (option) {
        if (Array.isArray(option.value)) {
          return I.is(I.List(option.value), valuesList);
        }
        return values.indexOf(option.value) >= 0;
      });
      return selectedItems.length && selectedItems.map(function (_ref4) {
        var label = _ref4.label;
        return label;
      }).join(", ");
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          filterLabel = _props.children,
          className = _props.className,
          options = _props.options;

      var rootClassName = (0, _classnames2.default)("erg-components-DropdownFilter", "erg-font-sm", className);
      return _react2.default.createElement(
        "div",
        { className: rootClassName },
        filterLabel && _react2.default.createElement(
          "label",
          { className: "erg-margin-right-5" },
          filterLabel,
          ":"
        ),
        _react2.default.createElement(
          _reactBootstrap.DropdownButton,
          {
            bsSize: "small",
            bsStyle: "link",
            id: "dropdown",
            pullRight: true,
            title: this.currentLabel || "" },
          options.map(function (option, idx) {
            return _this2.renderOption(option, idx);
          })
        )
      );
    }
  }, {
    key: "currentLabel",
    get: function get() {
      var _props2 = this.props,
          defaultLabel = _props2.defaultLabel,
          defaultValue = _props2.defaultValue;

      return this.getLabelByValues(this.currentValue) || this.getLabelByValues(defaultValue) || defaultLabel;
    }
  }, {
    key: "currentQuery",
    get: function get() {
      return this.currentValue.length ? _defineProperty({}, this.props.param, this.currentValue) : {};
    }
  }, {
    key: "currentValue",
    get: function get() {
      var query = this.context.location.query;
      var _props3 = this.props,
          defaultValue = _props3.defaultValue,
          multi = _props3.multi,
          options = _props3.options,
          param = _props3.param;


      var res = [];
      if (query[param]) {
        res = Array.isArray(query[param]) ? query[param] : [query[param]];
      } else if (defaultValue) {
        res = defaultValue;
      } else if (!multi) {
        res = [options[0].value];
      }

      return res;
    }
  }], [{
    key: "getDefaultQuery",
    value: function getDefaultQuery(props) {
      var defaultValue = props.defaultValue,
          param = props.param;


      return _defineProperty({}, param, defaultValue);
    }
  }]);

  return DropdownFilter;
}(_react.Component), _class.displayName = "DropdownFilter", _class.contextTypes = {
  location: _propTypes2.default.object.isRequired
}, _class.defaultProps = {
  defaultLabel: "All",
  defaultValue: [],
  multi: false
}, _class.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  defaultLabel: _propTypes2.default.string,
  defaultValue: _propTypes2.default.array,
  multi: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string, // eslint-disable-line react/no-unused-prop-types
    value: _propTypes2.default.oneOfType([// eslint-disable-line react/no-unused-prop-types
    _propTypes2.default.array, _propTypes2.default.number, _propTypes2.default.string])
  })).isRequired,
  param: _propTypes2.default.string.isRequired,
  queryToReset: _propTypes2.default.object,
  to: _propTypes2.default.string
}, _temp2);
exports.default = DropdownFilter;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-components-react/lib/filters/DropdownFilter.js
 ** module id = 792
 ** module chunks = 0
 **/